import Dashboard from "./index";

const BlogsDashboard = () => {
  return (
    <Dashboard>
      <h1>Blogs Dashboard</h1>
    </Dashboard>
  );
};

export default BlogsDashboard;
